const JdExample = [
  {
    name: 'ABS-资产证券化',
    children: [
      {
        name: '通用',
        content:
          '职责描述：\n1、负责债券相关业务开发。\n2、独立或合作完成项目判断、客户沟通。\n3、保持与债券发行人，中介机构的良好沟通。 \n4、收集和分析行业的最新动态。\n\n任职要求：\n1、本科以上学历，至少X年以上证券行业从业经验。\n2、具有相当的人脉资源，包括但不限于各类金融机构。\n3、能够承受较强的工作压力，具备良好的人际公关能力，对工作富有热情。\n4、有券商/银行项目承揽承销经验者优先。',
      },
      {
        name: '承揽',
        content:
          '岗位描述：\n1. 负责资产证券化业务的开拓和项目储备；\n2. 负责项目渠道及合作伙伴关系的建立，拓展并维护公司与资本市场的关系；\n3. 寻找满足标准的项目，负责项目的市场机会分析、项目调研、可行性分析，组织商务谈判、产品方案策划及风险管理分析；\n4. 组建团队，负责对接内外部资源，促进项目落地；\n5. 带领团队完成资产证券化产品的推介路演及承销工作；\n6. 跟踪完成资产证券化项目存续期管理工作\n\n任职要求：\n1. 全日制硕士研究生以上学历，金融、经济相关专业；\n2. 五年以上从业经验，三年以上资产证券化相关经验，完成多个资产证券化项目；\n3. 目标导向，具备良好的沟通能力、组织协调能力和团队合作能力；',
      },
      {
        name: '承做',
        content:
          '岗位职责\n1.参与资本市场分析，开拓业务合作机会；\n2.对接资产证券化项目的开发与落地；\n3.对接公司各业务的交叉销售与资源整合工作；\n4.协助销售团队完成金融产品的发行。\n岗位要求\n1、全日制硕士及以上学历，金融、财务、法律等相关专业；\n2、至少4年以上金融机构工作经验，熟悉资本市场业务运作；\n3、具备证券及基金从业资格；\n4、具有较强的沟通协调能力、谈判能力、应变能力以及商业风险评估分析和控制能力；\n5、有ABS、CMBS、融资租赁、供应链融资、公开市场融资等成功经验优先考虑。',
      },
      {
        name: '销售',
        content:
          '工作职责:\n1、负责ABS的承销工作，参与定价、询价、路演、推荐等工作；\n2、挖掘各类销售渠道，协助相关资源的开发，做好对接客户工作；\n3、跟踪ABS市场的动态，为部门发行工作提供相关支持；\n4、负责与其他部门沟通、协调等工作；\n5、完成部门交办的其他工作。\n任职资格:\n1、财会、金融、法律、管理相关专业，硕士研究生及以上学历；\n2、具有2年及以上ABS或债券销售经验；\n3、通过证券从业、CFA、CPA者优先；\n4、具有强烈的责任心，认真负责，积极主动，适应能力强；\n5、性格外向开朗，热爱销售工作，抗压能力强，具有良好的沟通协调能力。',
      },
    ],
  },
  {
    name: 'COM-合规',
    children: [
      {
        name: '通用',
        content:
          '岗位职责：\n1、负责合规管理制度、工作流程的建立和执行，监督公司内部管理制度和业务规则的合规性，解决执行中的重大问题；\n2、对公司重大决策和主要业务活动进行合规审核；\n3、对公司的合规状况进行监测和检查，及时发现违法违规行为，按照职责分工和程序进行查处或移交处理，并按照规定报告；\n4、负责与监管部门之间的沟通协调；\n5、负责组织公司管理层和全体员工对法律、法规、规章、规范性文件和公司制度的学习、培训和宣导；\n6、为公司决策层、管理层和业务部门提供合规咨询。\n任职要求：\n1、全日制硕士及以上学历，法律、金融、经济、财务等相关专业；\n2、具有 8 年以上金融行业法律合规、风险控制管理工作经验；\n3、诚实守信，为人正直，具备良好的职业操守及严谨的工作态度。具有较强的领导和管理能力、沟通协调能力、分析判断能力，通晓证券法律、法规和准则，具有胜任合规管理工作需要的专业知识和技能。\n4、持法律职业资格证书、CPA、CFA 者优先考虑。',
      },
    ],
  },
  {
    name: 'DS-渠道销售',
    children: [
      {
        name: '通用',
        content:
          '岗位职责\n1. 负责公募产品投资规划制定和投研体系建设管理，组织实施权益产品投资策略、资产配置等；\n2. 构建股票投资组合，在控制风险的情况下完成产品既定投资目标；\n3. 部门领导交代的其他事项。\n岗位要求:\n1. 5年以上投资管理经验，8年以上从业经验，具备公募基金、证券、保险等权益产品管理工作经验或公募基金、证券公司买方研究经验，拥有公募基金团队管理经验者优先；\n2. 具有公开的业绩记录，3年平均回报位于可比范围前30%，管理资产规模超过20亿；\n3. 崇尚研究驱动的投资文化，具备扎实的基本面研究功底，对行业和公司有深刻的理解，在深入研究的基础上建立成熟的投资风格，注重对组合风险的控制；\n4. 国内外知名院校硕士及以上学历，原则上其本科要求为985/211院校，经济、金融、财务、数理及相关专业，取得CFA、FRM、CPA等证书者优先；\n5. 认同公司企业文化，富有进取心、责任心，勤奋、敬业、工作严谨、目标导向，具备优秀的人际沟通技巧和团队协作精神，具有极强的抗压能力。',
      },
    ],
  },
  {
    name: 'FI-债券开发执行',
    children: [
      {
        name: '通用',
        content:
          '岗位职责\n1、负责开发、维护固定收益市场各类金融机构客户，紧密跟踪市场形势，挖掘业务机会；\n2、立足FICC业务优势，协调并满足部门内外部各交易台的交易需求；\n3、负责现券销售交易、债券转售，配合进行信用债及利率债一二级联动业务开展；\n4、对客户的交易数据进行分析和统计，协助完成内部数据库及系统建设工作；\n5、服从整体安排，及时响应部门或销售条线安排的其他工作内容。\n岗位要求\n1、重点院校全日制硕士及以上学历，经济、金融、财务等相关专业； \n2、熟悉债券市场各交易品种及相关交易流程规则，对债券市场有全面深入的了解\n3、5年以上债券交易、销售相关工作经验，具有金融机构客户资源，具备客户网络搭建能力； \n4、具有良好的综合素质和沟通能力，具备较强的人际交往及组织协调能力；\n5、具备银行间市场交易员资格者优先。',
      },
      {
        name: '承揽',
        content:
          '岗位职责\n1、参与债券项目承揽工作；\n2、负责建议书的编写、债券发行方案的设计；\n3、独立完成项目尽职调查、方案论证及具体实施；\n4、负责起草与项目相关的报送审批文件（募集说明书等），并具体办理审批手续；\n5、负责发行项目承做过程中与其他机构日常谈判、协调等事宜；\n6、配合市场拓展、项目发行、维护客户关系；\n7、对债券承销业务领域新问题、新产品、新趋势等进行研究、总结。\n\n岗位要求\n1、专业能力：具有扎实的财务功底，熟悉债券承做流程，具备注册会计师资格、中级会计职称优先；\n2、学历要求：硕士及以上学历，财务管理、会计、经济、法律等相关专业背景优先；\n3、工作经验：2年以上债券承做相关工作经验。债券承做：',
      },
      {
        name: '承做',
        content:
          '岗位职责\n1、参与债券项目承揽工作；\n2、负责建议书的编写、债券发行方案的设计；\n3、独立完成项目尽职调查、方案论证及具体实施；\n4、负责起草与项目相关的报送审批文件（募集说明书等），并具体办理审批手续；\n5、负责发行项目承做过程中与其他机构日常谈判、协调等事宜；\n6、配合市场拓展、项目发行、维护客户关系；\n7、对债券承销业务领域新问题、新产品、新趋势等进行研究、总结。\n\n岗位要求\n1、专业能力：具有扎实的财务功底，熟悉债券承做流程，具备注册会计师资格、中级会计职称优先；\n2、学历要求：硕士及以上学历，财务管理、会计、经济、法律等相关专业背景优先；\n3、工作经验：2年以上债券承做相关工作经验。债券承做：',
      },
    ],
  },
  {
    name: 'FII-固收投资',
    children: [
      {
        name: '通用',
        content:
          '岗位描述：\n1. 负责公募固收产品规划、投研体系建设及管理，组织研究和实施固收产品投资策略、资产配置等；\n2. 负责构建固定收益投资组合，在控制风险的情况下完成产品既定投资目标；\n3. 部门领导交代的其他事项。\n岗位要求:\n1. 5年以上投资管理经验，8年以上从业经验，具备公募基金、证券、保险或银行相关工作经历，拥有公募基金团队管理经验者优先；\n2. 具有成熟的投资理念、投资框架，具备较大规模资产管理经验，管理资产规模超过100亿；有公开的业绩记录，且业绩位于同业可比前1/3；\n3. 具有扎实的宏观经济学背景，熟悉国内宏观政策环境，并对利率有独到深入的研究；\n4. 有优异的利率债投资业绩，具备丰富的信用债和资产证券化品种的投资经验，并对固定收益组合的风险控制有深刻理解；\n5. 国内外知名院校硕士及以上学历，原则上其本科要求为985/211院校，经济、金融、财务、数理及相关专业，取得CFA、FRM、CPA等证书者优先；\n6. 认同公司企业文化，富有进取心、责任心，勤奋、敬业、工作严谨、目标导向，具备优秀的人际沟通技巧和团队协作精神，具有极强的抗压能力。',
      },
    ],
  },
  {
    name: 'FIN-财务',
    children: [
      {
        name: '通用',
        content:
          '岗位职责：\n1、负责公司的财务管理工作；\n2、参与制定财务管理制度，梳理财务管理流程，落实执行情况，反馈存在问题，并提出解决意见；\n3、完成上级交办的其他事项.\n\n岗位要求\n1、全日制硕士研究生及以上学历，本科及硕士毕业院校应享有一定知名度及学术地位，具有中级会计师以上职称或注册会计师资格者优先；\n2、具有5年以上证券公司财务工作经验；\n3、具备良好的财务管理、财务分析、税务法规及相关专业知识；\n4、有较好的沟通协调能力、高度的责任感和敬业精神，及财税政策学习研究能力。',
      },
    ],
  },
  {
    name: 'FIR-固收研究',
    children: [
      {
        name: '通用',
        content:
          '职责描述：\n1. 进行债券市场分析，负责信用债、城投债、利率债等固定收益类产品的研究，定期完成分析报告，提供固收投资建议；\n2. 跟踪宏观经济形势和相关政策、行业变化，跟踪各类固收产品的市场走势，完善固收产品分析、配置研究框架；\n3. 提供专题研究、路演、培训、咨询等研究服务；\n4. 进行适量的询券、资金拆借等组合支持工作。\n\n任职要求：\n1. 硕士及以上学历，具有1年以上固收投资研究经验优先；\n2. 熟练掌握债券相关知识，对债券兴趣浓厚；\n3. 具备良好的信息收集、信息处理和数据分析能力；\n4. 自我驱动力强，致力于长期从事投研相关工作，勤奋踏实、严谨自律，能承受较大的工作压力；\n5. 有一定的交易对手资源、资金资源优先。',
      },
    ],
  },
  {
    name: 'FIS-债券销售',
    children: [
      {
        name: '通用',
        content:
          '职位描述：\n1、负责各品种信用债销售交易、债券转售，配合进行固定收益类产品的推介、路演、询价及一、二级联动业务开展；\n2、立足FICC业务优势，协调并满足部门内外部的投资、交易等各项需求；\n3、负责开发、维护固定收益市场各类金融机构及企业客户、跟踪投资者动态；\n4、对市场发行及客户交易数据进行分析和统计，协助完成内部数据库及系统建设工作，紧密跟踪市场形势，挖掘业务机会；\n5、关注市场变化，搜集市场信息，及时响应部门或销售条线安排的其他工作内容。\n\n任职资格:\n1、全日制统招本科及以上学历，经济、金融、管理类相关专业；\n2、个性开朗外向、对销售工作充满热情，并具备及良好的沟通协调能力、抗压能力及逻辑思维能力；\n3、熟悉债券市场各交易品种及相关交易流程规则，对债券市场有全面深入的了解；\n4、通过证券从业资格考试，具有1年以上债券业务从业经验，有债券销售交易经验优先考虑；\n5、券商销售交易部门、货币中介交易台、商业银行投行及金融市场部门从业经验优先考虑；',
      },
    ],
  },
  {
    name: 'FOF-FOF',
    children: [
      {
        name: '通用',
        content:
          '工作职责\n1、 负责公司FOF部门的规划，把握产品和市场的发展方向；\n2、 负责公司FOF产品的设计及整体运营;\n3、 管理或参与新业务团队建立，试运行新的业务模式，完成孵化过程；\n4、 与金融同业保持较好的沟通，提出新的发展方向和可能的业务模式。\n任职要求：\n1、硕士及以上学历，金融、经济学相关专业优先；\n2、对FOF产品的未来发展有清晰的认识，并具有相关金融机构FOF产品发行、运营经验；\n3、具备3年以上银行、券商、保险、基金、信托、资产管理公司等金融机构的工作经验；\n4、具备良好的金融销售渠道资源或其相关经验者优先；\n5、具备扎实的金融知识背景，对大类资产配置有深刻的理论与实践基础；\n6、具有良好的职业操守、保密意识、协调沟通能力和全局观。',
      },
      {
        name: '投资',
        content:
          '职责描述：\n1.负责各类型基金产品组合的研究、尽调、业绩分析、筛选、监控等，并熟练运用量化方式进行评价分析\n2.负责FOF组合的构建与管理，制定FOF产品投资策略及资产配置计划，对宏观市场有一定认识和见解，跟踪分享宏观数据及政策，制定落实投资策略，调整基金投资必争或替换基金，协助开展投资框架完善工作\n3.良好的数据处理能力 ，建立量化模型，对投资对象进行筛筛选、研究和尽职调查，形成分析研究报告，维护FOF的备投池，不断优化模型和分析方法\n4.负责团队量化对冲策略体系建立和完善，量化投资策略框架的设计、策略开发模型构建和投资决策关哦里，发型和管理量化对冲产品\n\n任职要求：\n1.全日制本科及以上学历；金融、理工专业优先\n2.3年以上投资管理研究数据，具备数据处理分析能力，了解python等程序语言\n3.对市场量化及衍生品类策略及及结构有深入了解及联系\n5.工作效率高，抗压能力强\n6.具有私募量化基金管理或公募基金管理经历',
      },
      {
        name: '研究',
        content:
          '岗位职责：\n1. 根据公司战略发展需要，挖掘各类资产配置优秀的证券子基金；\n2. 配合公司母基金业务开展，进行证券市场各类配置研究，并不断完善研究体系；\n2. 根据宏观经济、证券市场、行业和投资品种研究撰写分析报告\n4. 负责我司策略投资组合下的项目进行深入研究分析和跟踪；\n5. 针对公司意向机构进行商务合作开发洽谈，达成合作；\n6. 针对母基金FOF市场进行深入调查研究\n\n任职要求：\n1. 经济、数学、金融相关专业全日制硕士及以上学历（特别优秀者可例外） ；\n2. 具有3年以上券商、基金和银行投资管理经验和优异业绩；\n3. 熟练掌握Microsoft Office等办公软件和各类证券分析软件；\n4. 具备CFA、CPA或相关资格者为佳，具备较强的宏观经济形势分析能力，思路清晰；\n5. 良好的沟通协调能力和团队合作精神，敏锐快捷的市场反应能力和执行力，较强的风险控制意识；\n6. 具有长期从事FOF产品经验优先\n7. 具备长期与私募机构合作经历者优先',
      },
    ],
  },
  {
    name: 'HK-IBD',
    children: [
      {
        name: '通用',
        content:
          '工作职责:\n1.Establish a holistic understanding of clients\' needs and deliver innovative high value solutions across all IBD product lines, gaining sustainable returns；\n2.Develop and maintain the "CXO level " relationship and access at key decision maker level for current assigned and target clients；\n3.Manage origination/execution teams established for particular deals and ensure that deals can completed timely and effectively.\n\n任职资格：\n1. Undergraduate degree from a leading university;\n2. Excellent verbal and written communication skills in both English and Mandarin Chinese, strong interest in the financial markets, strong analytical and numerical skills;\n3.Industry expert and ability to detect and interpret correctly business trends, market signals, new policies, regulation and practices and their impact on business;\n4.Proven successful record on deal originating and execution;\n5. More than 9 years investment banking experience, experienced HK/US IPO execution banker, ability to communicate with and manage CXO level efficiently, leadership in origination/deal structuring/client management, solid execution skill, strong industry know-how in To B industries (SaaS, Technology, Enterprise Services, etc.) will be preferred.',
      },
    ],
  },
  {
    name: 'IBD-投行',
    children: [
      {
        name: '通用',
        content:
          '职责描述\n1.保荐承销、财务顾问、并购重组等投资银行业务的承做，协助进行项目承揽\n2.投资银行项目的尽职调查、材料制作和上报、监管机构沟通;\n3.企业及其他中介机构等项目参与方的沟通协调;\n4.行业研究、估值定价\n5.客户需求挖掘与合作关系维护。\n\n任职要求:\n1会计、法律、金融、经济、财务等专业硕士及以上学历，通过CPA、司法或保荐代表人考试者优先;\n2两年以上投资银行、会计师事务所、律师事务所行业研究或上市公司相关工作经验，具有较强的财务功底和业务能力者可适当放宽;\n3.具有较强逻辑思维能力、方案写作能力、团队合作精神和抗压能力，认同公司文化和价值观，富有进取能够快速融入团队并起到骨干作用。',
      },
    ],
  },
  {
    name: 'IS-机构销售',
    children: [
      {
        name: '公募基金',
        content:
          '职责描述：\n1、针对所负责区域内的机构客户和销售渠道进行开发与维护，包括日常客户走访，向客户提供市场咨询，与客户保持良好关系。\n2、根据公司产品销售计划，推动产品日常销售服务工作；负责公司整体营销方案的具体落地执行。\n3、能够专业合规地进行公司产品的路演推介。对国内外重大的事件、政策和数据变化进行及时学习更新，能提供时效性强短评。\n4、完成公司交办的其他工作。\n\n任职要求：\n1、重点院校金融相关专业本科及以上学历，接受应届毕业生，1-2年相关工作经验者为佳。\n2、具备优秀的对外沟通能力，文字功底强。具备基金从业资格者优先。\n3、富有激情，团队协作精神佳，具有独立思考和分析判断能力。',
      },
      {
        name: '私募基金',
        content:
          '职责描述：\n1. 负责机构销售业务的开发和营销工作，达成销售指标。\n2. 负责当地机构渠道的合作开发及对接维护，根据公司产品项目制定发行销售方案并部署实施。\n3. 推动和扩大与机构客户的合作范围及合作渠道，参与策划、谈判、产品规划。\n4. 配合相关部门做好与现有合作机构的业务开展，同时积极拓展与新机构客户的业务合作。\n5. 其他机构销售相关事务。\n\n任职要求：\n1. 全日制本科及以上学历。\n2. 2年以上渠道销售经验。\n3. 具有良好的沟通协调技巧、敏锐快捷的市场反应能力及较强的风险意识，能承受较强的工作压力。\n4. 品行端正，思维敏捷、严谨细致、踏实负责，具有较强的团队协作精神。\n5.具有丰富客户资源者优先考虑。',
      },
      {
        name: '保险资管',
        content:
          '工作职责:\n1.负责营销及维护养老金战略客户，达成公司销售任务；\n2.有效整合内外部资源，服务养老金战略客户的个性化需求并提供解决方案；\n3.制作销售活动相关材料、跟踪养老金市场动态、分析市场数据\n4.协调、梳理相关业务流程，优化业务效率。\n\n任职资格:\n1.本科以上学历；\n2.经济、金融、管理或相关专业优先，具备金融市场基础知识、了解各类金融资产的特性\n3.具备较高的excelppt等办公软件技能、熟练掌握wind等资讯软件\n4.具备较好的客户服务意识，善于沟通交流、有大型客户营销、服务支持经验者优先；\n5.以结果为导向，能够自我驱动目并积极调动相关资源，接受加班和出差。\n6.具备较好的职业素养、对待工作责任心强，仔细认真。',
      },
      {
        name: '银行',
        content:
          '职位描述：\n1、推广公司在区域市场上的品牌知名度、维护公司价格体系、引导客户需求 ；\n2、搜集并分析客户、竞争对手信息，对区域内市场进行分析和评估并提出建议；\n3、持续开拓维护区域内银行（包括大行、城商行、商业银行等）客户；\n4、实施销售计划，完成客户拜访，项目挖掘，掌控项目进度，跟进项目招投标，协调并整合公司内外部的资源完成所负责项目投标及上线 ；\n5、落实签单，跟进项目上线、测试，监控项目运营数据，保证项目正常运营并执行回款任务，提升客户满意度，完成年度销售任务。\n\n任职资格：\n1、8年以上行业大客户销售工作经验，有相关业产品销售经验优先考虑；\n2、熟悉项目招投标过程，讲解ppt等各种业务交流；\n3、本科以上学历，有相关团队管理经理',
      },
      {
        name: '证券',
        content:
          '岗位职责：\n1.负责辖区内客户关系建设和维护，市场分析与规划、项目运作及达成销售目标；\n2.制定销售策略，执行销售活动，完成销售指标；\n3.负责辖区内新客户、新市场的开拓，并与客户建立长期、稳定的关系；\n4.对区域市场的业务发展构建良性的公共关系；\n5.主动挖掘、分析、引导不同客户的关键需求；\n6.做好项目过程控制，识别各项目关键节点的风险，及时解决及防范；\n7.掌握区域市场的项目机会、目标客户、竞争格局及发展趋势，为市场规划提供决策依据。\n职位要求：\n1.统招本科及以上学历，3年以上销售工作经验；\n2.思路清晰，对销售工作充满激情；较好的协调和执行能力，团队协作强，形象气质佳，职业素养高；\n3.熟悉解决方案型销售模式，有政府、电子政务、智慧城市、智慧社管项目经验者优先。',
      },
      {
        name: '上市公司',
        content:
          '岗位职责：\n1.根据公司计划开拓市场，开发、维护客户群，完成销售与推广任务；\n2.与基金、券商客户进行有效沟通，深挖客户各业务部门需求，建立与基金、银行客户的长期合作关系；\n3.根据公司销售战略和计划，制定对应区域的销售策略，设定团队考核计划，监督团队完成业绩考核，并确保有效执行；\n4.管理和指导团队并制定团队销售计划，定期提交销售进度报告，分析销售情况；\n5.负责渠道的开拓及维护。\n\n任职要求：\n1. 全日制本科及以上学历，金融、电子商务、市场营销、传媒专业优先；\n2. 5年以上工作经验，有金融数据、金融端系统销售作经验、恒生/万得等相近企业工作经验优先；\n3. 喜欢销售工作，有敬业精神和团队精神，对新闻有较高的敏感度；\n4. 有较强的学习意识和学习能力，承担销售业绩考核。',
      },
    ],
  },
  {
    name: 'KC&QC-内核&质控',
    children: [
      {
        name: '通用',
        content:
          '职责描述：\n1、负责投行类业务质量控制审核，包括但不限于：项目立项审核；质控初审；项目的进展和动态跟踪；现场检查；工作底稿检查验收；监管机构审核、发行阶段、持续督导阶段的文件审核等；\n2、参与投行类业务制度建设。\n3、案例研究。\n任职要求：\n1、全日制硕士及以上学历，财务、会计、法律、金融经济等相关专业；\n2、具备5年以上证券公司投行、质控等经历或5年以上会计师事务所（律师事务所）证券类业务工作经验；\n3、有保代、准保、注会、律师资格者优先考虑。',
      },
    ],
  },
  {
    name: 'LEGAL&COM-法务合规',
    children: [
      {
        name: '通用',
        content:
          '工作职责\n1．负责制定股权投资子公司各项风险管理制度、执行风险管理政策；\n2．对公司的法律合规等风险进行监控管理，开展监察稽核、制作监察稽核报告；\n3．负责公司内部法律合规事务咨询、政策研究，内控制度体系的完善和执行情况的检查；\n4．负责拟投项目的风险情况进行评估，对已投项目的风险收益特征进行定期分析和回顾；\n5．负责对基金产品募集过程的风险进行管理和评估。\n\n任职要求\n1．国内外一流高校毕业，硕士及以上学历，法律、金融等相关专业优先考虑；\n2．三年以上律师事务所、股权投资公司相关工作经验，通过法律职业资格考试者优先；\n3．诚信正直、勤勉尽责、品行端正，具备较强的风控意识、团队精神和良好的职业操守。',
      },
    ],
  },
  {
    name: 'PEVC-股权投资',
    children: [
      {
        name: '通用',
        content:
          '职责描述：\n1、负责独立开拓公司重点关注领域的股权项目，建立稳定的项目来源体系，为公司挖掘、筛选优质的投资项目。\n2、负责建立和维护相关行业的渠道资源，包括但不限于市场化投资机构、政府引导基金等。\n3、负责对拟投项目组织开展全面尽职调查、财务审计和资产评估（如需），撰写项目决策支持文件（投资建议书、尽职调查报告等）。负责独立或指导团队完成细分领域的行业研究，撰写行业分析报告，清晰鉴别行业机会和风险。\n4、负责投资条款商务谈判、投资协议签署、投资款项安排、股权工商变更等事项，完成项目交割。\n5、负责公司投资项目的投后管理、投资退出等工作\n\n任职要求：\n1、金融、法律、财务、管理等相关专业本科及以上学历；\n2、具有较为丰富的投资及投资管理经验，对重点关注的领域有清晰的投资策略和逻辑，具有敏锐的投资判断能力和很强的商务谈判能力，成功负责过股权投资项目并具有良好的业绩，有成功退出经验；\n3、在股权投资领域具有丰富的渠道和项目资源；\n4、熟悉相关法律、法规和政策，具备较强的风险防范能力，了解投资过程中涉及的各类投资风险，熟悉尽职调查、交易结构设计、商务谈判、项目执行等实际操作流程；\n5、责任心强，工作态度端正，认真负责，具备良好的团队合作精神、良好的沟通及表达能力。',
      },
      {
        name: '医药医疗/大健康',
        content:
          '岗位职责：\n1、负责医药医疗、大健康项目投资执行，包括参与项目筛选，主导大健康项目调研、立项、尽调、投资建议等项目投资决策支持工作；\n2、主导医药医疗、大健康领域行业、产业研究，专项研究等相关投资研究工作；\n3、拓展和寻找符合股权投资业务方向、符合集团产业园区优质产业项导入标准的项目和渠道资源；\n4、协助项目投后管理；\n5、高效完成集团领导和总经理布置的其他工作。\n\n任职要求：\n1、医学、药学、生物工程、生物制药相关专业本科及硕士毕业优先，全日制统招优秀院校毕业优先；\n2、5年以上大健康领域投资经验，具有2个以上医疗大健康成功退出案例，在、丰富的投资经验，对行业风险和风控有独到见解，具有丰富的医疗大健康项目资源、渠道资源；\n3、在大健康领域具备丰富的投资分析和判断能力；具有较强的项目渠道，具有良好的产业研究能力；\n4、价值观积极向上，务实高效，具有团队协作精神。',
      },
      {
        name: '大消费',
        content:
          '岗位职责：\n1、重点关注大消费领域的投资机会；\n2、收集项目资源，进行跟踪调查，对初选项目进行前期调研；\n3、对项目进行全面尽职调查、并撰写行业和项目研究报告，对投资价值与风险进行评估；\n4、负责项目投资谈判和交易执行；\n5、定期对被投公司的后续管理；\n6、参与其他项目工作。\n\n任职要求：\n1、国内外院校金融、经济等相关专业本科及以上学历，5年-10年相关工作经验；\n2、熟悉大消费领域，具有丰富的行业人脉资源，独特的分析和判断能力，有产业背景优先；\n3、执行力强，严谨认真、注重团队合作；\n4、具备较强的工作抗压能力及能适应加班和出差。',
      },
      {
        name: '高端制造',
        content:
          '工作职责:\n1. 负责相应行业研究及项目研究，出具投资/研究报告；\n2. 协助完成公司投资策略研究，并对拟投资的领域/项目进行分析、甄别、筛选；\n3. 参与公司行业投资研究体系的建立和完善；\n4. 熟练完成投资项目价值分析评估等工作，为公司的投资决策提供依据；\n5. 完成部门负责人交办的其他工作。\n\n任职资格:\n1. 国内外大学硕士以上学历，理工科专业背景优先；\n2. 2年以上投行、基金、证券、资产管理等机构行业研究经验或股权投资经验；\n3. 财务分析、行业研究基础扎实，熟悉企业服务领域优先；\n4. 有高度的团队精神，有较强的沟通协调能力及高度责任心，有较强的创新和学习能力。',
      },
      {
        name: '环保能源',
        content:
          '岗位职责：\n1. 及时追踪、分析和研究国内不动产市场，对投资方向提出建议；\n2. 协助完成投资项目价值评估，对拟投资项目进行投资分析论证，确保投资的回报率和安全可靠性；\n3. 协助项目负责人完成基金直投项目的项目筛选+D252、项目尽调、交易结构设计、合同谈判、投后管理等工作；\n4. 完成部门及项目负责人交办的其他工作\n任职资格：\n1. 国内外重点大学金融、经济、房地产等专业硕士以上学历；\n2. 2年及以上券商、基金、资管机构地产行业研究经验或宏观策略研究经验；\n3. 具备较强的市场研究能力、良好的投资分析判断能力；扎实的财务分析、测算功底；\n4. 较强的沟通协调能力及高度责任心，积极主动，有较强的创新和学习能力',
      },
      {
        name: '房地产',
        content:
          '岗位职责：\n1. 及时追踪、分析和研究国内不动产市场，对投资方向提出建议；\n2. 协助完成投资项目价值评估，对拟投资项目进行投资分析论证，确保投资的回报率和安全可靠性；\n3. 协助项目负责人完成基金直投项目的项目筛选、项目尽调、交易结构设计、合同谈判、投后管理等工作；\n4. 完成部门及项目负责人交办的其他工作\n任职资格：\n1. 国内外重点大学金融、经济、房地产等专业硕士以上学历；\n2. 2年及以上券商、基金、资管机构地产行业研究经验或宏观策略研究经验；\n3. 具备较强的市场研究能力、良好的投资分析判断能力；扎实的财务分析、测算功底；\n4. 较强的沟通协调能力及高度责任心，积极主动，有较强的创新和学习能力',
      },
      {
        name: '科技',
        content:
          '岗位职责：\n1、重点关注硬科技领域的投资机会；\n2、收集项目资源，进行跟踪调查，对初选项目进行前期调研；\n3、对项目进行全面尽职调查、并撰写行业和项目研究报告，对投资价值与风险进行评估；\n4、负责项目投资谈判和交易执行；\n5、定期对被投公司的后续管理；\n6、参与其他项目工作。\n\n任职要求：\n1、国内外院校理工科等相关专业本科及以上学历，5年-10年相关工作经验；\n2、熟悉硬科技领域，具有丰富的行业人脉资源，独特的分析和判断能力，有产业背景优先；\n3、执行力强，严谨认真、注重团队合作；\n4、具备较强的工作抗压能力及能适应加班和出差。',
      },
      {
        name: 'AI',
        content:
          '职责描述：\n1、在专业领域内开展行业分析工作，能够系统梳理产业链及筛选头部标的；\n2、投资业务拓展，能够通过各种渠道寻找有发展潜力和投资价值的项目；\n3、进行项目的尽职调查，正确分析评估项目的投资价值与风险；\n4、投资方案的设计及被投资企业的后续管理与增值服务；\n5、需具有良好的项目、人脉资源，能带领团队开展投融资业务。\n任职要求：\n1、硬科技（半导体、人工智能）股权投资方向：1人\n国内外知名院校理工科相关专业硕士或博士学历，五年以上工作经验，其中至少3年以上芯片、计算机或人工智能等产业工作经历，且至少有两年以上的投资经验，熟悉VC、PE领域的运作规律及操作模式，有半导体行业研究或成功投资案例者可优先考虑；\n2、熟悉国内外金融政策、法规，在政府、投资机构、投行及中介机构有广泛的人脉资源，具有良好的沟通能力和执行能力；\n3、具备良好的财务、金融和企业管理知识及能力，具有行业研究分析经验，能够带领团队开展相关研究工作，为拓展投融资业务提供支持。',
      },
      {
        name: 'TMT',
        content:
          '工作职责\n1.负责TMT募投管退全流程投资融资工作；\n2.负责资金募集、基金设立，能主导基金设立运营的具体工作。\n3.负责项目投资全进程：项目研判、交易设计、尽职调查、项目落地等；\n4.负责项目投后管理，协助被投资企业提升经营业绩和管理水平，提供增值服务；\n5.推进落地项目退出，实现投资利益最大化。\n岗位要求\n1、学历要求：本科(含)以上。\n2、专业：经济学、金融学、财务、法律等相关专业，具有扎实的金融及财经理论知识。有中概股相关项目经验。\n3、工作经验：10年以上，参与过国内、国际IPO项目或并购重组项目。具有会计师事务所或律师事务所工作经验者优先。\n其他要求：能适应长期出差。',
      },
      {
        name: '半导体',
        content:
          '工作内容\n1、负责半导体行业投资研究，完善全产业链投研框架，撰写行业及项目的投资研究报告； \n2、参与拟投项目的研究分析、尽职调查、专家访谈、上市可能性分析、投资文件撰写等工作； \n3、负责对已投项目的跟踪分析与评估管理，提交定期报告等。\n招聘条件\n1、985/211院校电子、计算机、精密仪器、化学、材料、经济、金融等相关专业教育背景，硕士或博士；\n2、具备泛半导体产业研发/巿场经验或投行、投资、事务所审计履历，也考虑综合素质强的应届毕业生；\n3、具有极强的责任感和进取心，适应多线程工作状态，有志于从事股权投资事业；\n4、文字功底和逻辑思维能力强，深度钻研和追求细节的性格；\n5、年龄不大于40岁。',
      },
      {
        name: '物流供应链',
        content:
          '职责描述：\n1.围绕集团整体战略和事业部投资规划，协助团队负责人进行物流、供应链服务及消费领域的行业研究和战略制定；\n2.寻找和筛选相关领域有发展潜力和投资价值的投资机会，开拓投资项目资源；\n3.负责实施和落实项目的各投资环节，包括估值定价、商务谈判、结构设计、外部协调、过程管理和风险控制；\n4.负责已投项目的相关投后管理；\n5. 领导交办的其他工作。\n\n任职要求：\n1. 国内知名院校硕士及以上学历，商科背景优先；\n2. 具备较好的行业研究能力和财务基础，四大审计咨询背景优先；\n3. 性格开朗、有团队合作精神、学习能力强、善于沟通。',
      },
    ],
  },
  {
    name: 'PM-投后管理',
    children: [
      {
        name: '通用',
        content:
          '职责描述：\n1、负责被投企业的投后管理，我司投资退出；\n2、协助被投企业开展组织诊断，形成投后管理及风险分析报告，为被投企业提供管理咨询建议、协助被投企业提高经营管理水平；\n3、参与被投企业所在行业的行业研究分析，建立体系化的行业理解及投资逻辑；协助被投企业融资或被并购。\n4、针对公司拟投资、合作类项目决策，从投后管理角度提出决策建议。\n\n任职要求：\n1、全日制大学本科及以上学历，投资管理相关专业毕业，拥有CPA、CFA、律师资格、基金从业资格者优先；\n2、3年以上投后管理工作经验及丰富的行业资源；具有公司股权融资、企业并购重组、风险投资、财务管理、医疗大健康行业经验优先；\n3、符合公司价值观，品行端正，奉献进取，勇于担当，踏实好学，追求卓越，心理素质过硬；\n4、具备较强的探究问题、人际关系构建、组织推动能力，同时具备良好的商业敏感、创新、沟通影响能力。',
      },
    ],
  },
  {
    name: 'QUANT-量化投资',
    children: [
      {
        name: '通用',
        content:
          '工作职责\n1、负责量化产品的投资管理工作，对公募/私募进行筛选评估、尽职调查和同类产品业绩跟踪分析，优化投资策略和分析方法；\n2、搜集整理市场不同量化策略的业绩表现，挖掘优秀管理人；\n3、关注金融市场动态，把握市场热点与风险，挖掘投资机会；\n4、量化产品投资的申购材料及合同准备、内部决议和各类投资流程的起草、已投项目的投后管理；\n5、领导交办的其他事项。\n\n工作要求\n1、全日制本科及以上学历；金融、理工专业优先\n2、3年以上投资管理研究数据，具备数据处理分析能力，了解python等程序语言\n3. 具备CFA、CPA或相关资格者为佳，具备较强的宏观经济形势分析能力，思路清晰；\n4. 良好的沟通协调能力和团队合作精神，敏锐快捷的市场反应能力和执行力，较强的风险控制意识；\n5. 具备长期与私募机构合作经历者优先考虑',
      },
    ],
  },
  {
    name: 'REI-地产投资',
    children: [
      {
        name: '通用',
        content:
          '工作职责描述：\n1.负责公募基础设施REITs基金旗下项目的整体监督与巡查；\n2.协助制定各项目运营预算和收入指标；\n3.维护和发展同政府部门的公共关系，确保项目各项工作顺利开展；\n4.跟踪项目区域市场供需、价格变化，识别、发现项目风险；\n5.参与公募基础设施REITs基金日常工作讨论，为业务决策提供数据支持。\n\n任职要求描述\n1.具有五年以上公路铁路/IDC/产业园运营、管理岗位工作经验，具备一定招商经验；\n2.熟知公路铁路/IDC/产业园的发展动态和趋势，熟知营运管理中涉及各种操作业务，能合理确定与实施公司中长期运营工作发展规划；\n3. 拥有卓越的沟通协调能力和自我驱动型的职业价值观。',
      },
    ],
  },
  {
    name: 'RI-研究',
    children: [
      {
        name: '通用',
        content:
          '【岗位职责】\n1、对所属研究行业的个股进行深入研究，通过数据分析，对行业相关细分子行业机会进行甄别和比较；\n2、掌握行业和公司的发展趋势和动态，建立行业数据库；\n3、撰写研究报告、提供投资建议，为公司组合管理提供准确及时的信息及参考；\n4、对基金经理的研究需求做出及时反馈。\n【岗位要求】\n1、知名大学硕士及以上学历，行业相关及金融复合专业背景优先；\n2、2-5年相关行业研究经验，具有公募基金、大型券商研究工作经验者优先；\n3、熟练使用各类行业分析软件；\n4、积极进取、良好的沟通能力。',
      },
    ],
  },
  {
    name: 'RISK-风控',
    children: [
      {
        name: '通用',
        content:
          '职责描述：\n1、参与拟投资项目的投资分析，拟订项目投后管理的方案，对项目公司付款、合同等的合规、合理性进行审核、报批；\n2、负责项目投后风险评估及风险管理，督促落实投资协议中风控措施，审核项目年度预算、月度资金计划，动态监控项目现金流和收益情况；\n3、对投资项目进行跟踪管理，对被投资企业的财务状况和经营情况进行监控，监控项目工程、成本、销售、资金等运营数据完成情况，及时进行风险预警；\n4、定期收集项目信息、当地市场数据、政策变化等，做好项目资料研判、分析，做好对外信息披露。\n\n任职要求：\n1、金融、经济、等相关专业本科及以上学历，具备相关资格者优先；\n2、证券分析、投资银行、创业投资企业/机构3年及以上相关工作经验；\n3、熟悉投资项目运作流程，对投资管理和风险控制有良好的理解能力，了解投资过程中涉及的各类投资风险；\n4、具有良好的职业道德，有上进心、责任心，有优秀的团队合作、沟通技能及执行力，有较强的文字表达能力；熟练使用办公软件；\n5、能够适应出差。',
      },
    ],
  },
]
export { JdExample }
